import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import ModaleConnexion from '../ModaleConnexion/ModaleConnexion';
import { APP_ROUTES, AUTHOR_NAME, AUTHOR_SITE_URL } from '../../utils/constants';
import './Footer.scss';

function Footer() {
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Ancres vers les sections de l'accueil, depuis n'importe quelle page.
  const goToSection = (id) => (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate(`/#${id}`);
    }
  };

  const handleConnexionClick = async () => {
    try {
      const res = await fetch('/api/auth/me', { credentials: 'include' });
      const data = await res.json().catch(() => ({}));
      if (data.authenticated) {
        navigate(APP_ROUTES.ADMIN_PANEL);
        return;
      }
    } catch {
      // ignore, on ouvre simplement la popup de connexion
    }
    setLoginModalOpen(true);
  };

  return (
    <footer className="footer">
      <div className="footer__inner">

        <div className="footer__div">
          <h2 className='h-footer'>Suivez BAsique</h2>
          <div className='footer-social'>
            <a href="https://www.facebook.com/epicerie.basique/" target="_blank" rel="noopener noreferrer" aria-label='Facebook' className='icon-footer-link'>
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://www.instagram.com/epiceriebasique/" target="_blank" rel="noopener noreferrer" aria-label='Instagram' className='icon-footer-link'>
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>

        <div className="footer__div">
          <h2 className='h-footer'>Liens</h2>
          <div className='footer-content__div'>
            <Link to="/" className='LinkNoStyle' onClick={scrollToTop}>Accueil</Link>
            <a href="/#produits" className='LinkNoStyle' onClick={goToSection('produits')}>Produits</a>
            <a href="/#vrac" className='LinkNoStyle' onClick={goToSection('vrac')}>Le vrac</a>
          </div>
        </div>

        <div className='footer__div'>
          <h2 className='h-footer'>Navigation</h2>
          <div className='footer-content__div'>
            <Link to="/sitemap" className='LinkNoStyle' onClick={scrollToTop}>Plan du site</Link>
            <Link to="/accessibility" className='LinkNoStyle' onClick={scrollToTop}>Accessibilité</Link>
            <Link to="/confidentiality" className='LinkNoStyle' onClick={scrollToTop}>Vos données</Link>
          </div>
        </div>

        <div className="footer__div">
          <h2 className='h-footer'>Mentions légales</h2>
          <div className='footer-content__div'>
            <p>Epicerie BAsique — Co-gérantes : Eva Traccard, Mathilde Nock</p>
            <p>SIRET : 94803082000013</p>
            <p>17 rue Anatole France, 42300 Roanne</p>
          </div>
        </div>

      </div>
      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} Épicerie BAsique — Tous droits réservés</span>
        <span className="footer__credit">
          Site réalisé par{' '}
          {AUTHOR_SITE_URL ? (
            <a href={AUTHOR_SITE_URL} target="_blank" rel="noopener noreferrer" className="footer__credit-link">{AUTHOR_NAME}</a>
          ) : (
            <span className="footer__credit-link">{AUTHOR_NAME}</span>
          )}
        </span>
        <button type="button" className="footer__connexion" onClick={handleConnexionClick}>
          Connexion
        </button>
      </div>

      {isLoginModalOpen && <ModaleConnexion onClose={() => setLoginModalOpen(false)} />}
    </footer>
  );
}

export default Footer;
